import React, { useState, useEffect  } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import * as UserActions from '../../../actions/UserActions'
import { LOCAL_STRAGE_KEY } from '../../../utils/Settings'
import AccountPasswordUpdateForm from '../parts/AccountPasswordUpdateForm'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
// import AccountShowUserStatistics from '../parts/AccountShowUserStatistics'
import CreateAccountForm from '../../pre_login/CreateAccountForm'
import AccountPaymentHistory from '../parts/AccountPaymentHistory'
import Footer from '../parts/Footer'


// AccountBase
const AccountBase = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  })
  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  let [loading, setLoading] = useState(false);
  let [pageName, setPageName] = useState('default');
  let [email, setEmail] = useState('')

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    // get email id
    await _getUserEmail(login_token)

    // await _getStatisticsForEachUser(login_token)
  }

  // get email id
  let _getUserEmail = async () => {

    try {
      // logout on server
      let _results = await MyAPI.getUserEmail({
        login_token: login_token
      })
      if (_results.status === "error") {
        throw Error(_results.message)
      }

      let email = _results.email
      setEmail(email.address)

    } catch (err) {
      console.log("err: ", err)

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // logout
  let _logout = async () => {

    try {
      // logout on server
      await MyAPI.logout({
        login_token: login_token
      })

      // delete storage key
      await localStorage.removeItem(LOCAL_STRAGE_KEY);

      dispatch(UserActions.loginWithEmail({}))

      // redirect to root
      navigate("/")

    } catch (err) {
      console.log("err: ", err)

      localStorage.removeItem(LOCAL_STRAGE_KEY);

      dispatch(UserActions.loginWithEmail({}))

      navigate("/")
    }
  }

  // show password change page
  let _gotoPasswordPage = () => {
    setPageName('password')
  }

  let _gotoStatsPage = () => {
    setPageName('statistics')
  }

  // _gotoCreateAccount
  let _gotoCreateAccount = () => {
    setPageName('create_account')
  }

  // _gotoPaymentHistory
  let _gotoPaymentHistory = () => {
    setPageName('payment_history')
  }

  // _accountCreated
  let _accountCreated = async () => {

    Alert.success("ok", {
      position: 'top-right',
      effect: 'slide',
      timeout: 5000
    });

    setPageName('default')
  }

  return (
    <div>

      <Header />

      {/* main */}
      <Container style={{
        marginTop: 20,
        minHeight: 400,
      }}>

        <Row style={{
          marginTop: 10,
          marginBottom: 10,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>
            <span>{email}</span>
          </Col>
          <Col md="6" xs="12" style={{
            textAlign: 'right',
          }}>

            {/*Link to="/payment_top" style={{
              color: '#000000',
              textDecoration: 'none',
            }}>
              <span style={{
                marginLeft: 6,
                marginRight: 6,
                cursor: 'pointer',
              }}>お支払い</span>
            </Link>*/}

            {user_info && user_info.profile && user_info.profile.account_type === "admin" && user_info._id !== "bd56cad0-7264-11eb-81ea-1dee2c2526a9" && (
              <span onClick={_gotoCreateAccount} style={{
                marginLeft: 6,
                marginRight: 6,
                cursor: 'pointer',
              }}>アカウントの追加</span>
            )}

            {user_info && user_info.profile && user_info.profile.account_type === "eval_user" && (
              <span onClick={_gotoPaymentHistory} style={{
                marginLeft: 6,
                marginRight: 6,
                cursor: 'pointer',
              }}>決済履歴</span>
            )}

            <span onClick={_gotoPasswordPage} style={{
              marginLeft: 6,
              marginRight: 6,
              cursor: 'pointer',
            }}>パスワードの変更</span>

            <span onClick={_logout} style={{
              marginLeft: 6,
              marginRight: 6,
              cursor: 'pointer',
            }}>ログアウト</span>
          </Col>
        </Row>

        <br/>
        <br/>

        {/* show something */}
        {pageName === 'password' && (
          <AccountPasswordUpdateForm login_token={login_token} />
        )}
        {pageName === "create_account" && (
          <CreateAccountForm
            setLoading={setLoading}
            adminLoginToken={login_token}
            accountCreated={_accountCreated}
            source="admin" />
        )}
        {pageName === 'payment_history' && (
          <AccountPaymentHistory
            setLoading={setLoading}
            login_token={login_token} />
        )}

      </Container>


      {/* footer */}
      <Footer />


      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default AccountBase
